<div class="panes" [@slide]="activePane">
    <div id="left-pane">
        <ng-content select="[leftPane]"></ng-content>
    </div>
    <div>
        <ng-content select="[rightPane]"></ng-content>
    </div>
</div>